import { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import SectionHeader from '../../components/SectionHeader';
import FormCard from '../../components/FormCard';

const linkClass =
  'cr-rounded-md cr-bg-blue-600 cr-px-3 cr-py-1.5 cr-text-sm cr-font-medium cr-text-white ' +
  'cr-no-underline hover:cr-bg-blue-700';

interface Tool {
  path: string;
  label: string;
  description: string;
}

/**
 * Landing page for the admin tools that have no home of their own.
 *
 * These used to be a row of buttons buried at the bottom of the single
 * Admin page. They are diagnostic rather than day-to-day, so they get a
 * submenu entry of their own instead of competing for attention with
 * team administration.
 */
const TOOLS: Tool[] = [
  {
    path: '/admin/design-system',
    label: 'Design System',
    description: 'Reference page for the shared components, colours and type scale.',
  },
];

export default function AdminDiagnostics(): ReactElement {
  return (
    <>
      <SectionHeader title="Diagnostics" />
      <FormCard>
        <div className="cr-flex cr-flex-col cr-gap-3 cr-p-3">
          {TOOLS.map((tool) => (
            <div
              key={tool.path}
              className="cr-flex cr-flex-col cr-gap-2 cr-rounded-md cr-border cr-border-gray-200 cr-p-3 md:cr-flex-row md:cr-items-center md:cr-justify-between"
            >
              <div className="cr-flex cr-flex-col cr-text-left">
                <span className="cr-font-medium">{tool.label}</span>
                <span className="cr-text-sm cr-text-gray-500">{tool.description}</span>
              </div>
              <Link to={tool.path} className={linkClass}>
                Open
              </Link>
            </div>
          ))}
        </div>
      </FormCard>
    </>
  );
}
